import React from 'react'
import { Link } from "gatsby"
import { slugify } from "../../util/utilityFunctions"

import TagNew from '../components/TagNew'

const LayoutBar = ({page, tags, tagCount }) => {

    const layout = page;

    return (

        <div className="items-center mt-8 md:mt-20">
            <div className="">
                {layout==="home" && <h3 className="text-xl font-bold tracking-tight dark:text-BaseLight lg:text-4xl">Projects</h3>}
                {layout==="tagSubject" && <h3 className="font-bold tracking-tight dark:text-BaseLight lg:text-4xl">View more projects:</h3>}
                {layout==="blog" && <h3 className="text-xl font-bold tracking-tight dark:text-BaseLight lg:text-4xl lg:mb-16">Articles</h3>}
            </div>
            <div>
                {layout==="tagSubject" &&
                    <ul className="flex flex-wrap w-full">
                        {tags.filter(tag => {return tag !== 'Blog'}).map(tag => (
                            <li key={tag} className="mt-4">
                                <Link to={`/projects/${slugify(tag)}`}>
                                    <TagNew key={tag} tag={tag} tagCount={tagCount}/>
                                </Link>
                            </li>
                        ))}
                    </ul>
                }
            </div>
        </div>
    )
}

export default LayoutBar
